import { render, staticRenderFns } from "./ParallelCoordinates.vue?vue&type=template&id=94908b98&scoped=true"
import script from "./ParallelCoordinates.vue?vue&type=script&lang=js"
export * from "./ParallelCoordinates.vue?vue&type=script&lang=js"
import style0 from "./ParallelCoordinates.vue?vue&type=style&index=0&id=94908b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94908b98",
  null
  
)

export default component.exports